

// Imports ---------------------------------------------------------------------

// Project
import { VueGlobalInjectable } from "~/libs/Types";
import PageLayout from "~/layouts/Default.vue";
import MainTitle from "~/components/MainTitle.vue";
import PageContent from "~/components/PageContent.vue";

// Export ----------------------------------------------------------------------

export default VueGlobalInjectable.extend({

    // Component imports -------------------------------------------------------

    components: {
        MainTitle,
        PageLayout,
        PageContent
    },

    // Component Attribute, Properties & Injected ------------------------------

    inject: ["node"]

    // -------------------------------------------------------------------------
});
